<!-- 教师中心 -->
<template>
  <div>
    <div class="addExperiment-title">
      <span @click="goRouter('/college')"
        >学院管理&nbsp;&nbsp; / &nbsp;&nbsp;</span
      >
      <span @click="goRouter('/teacherManage')"
        >教师管理&nbsp;&nbsp; / &nbsp;&nbsp;</span
      >
      <i>授课管理</i>
    </div>
    <div class="teachingManagement">
      <el-tabs v-model="tab" @tab-click="selectTab">
        <el-tab-pane label="授课班级" name="courses">
          <span v-if="tab=='courses'">
            <router-view></router-view>
          </span>
        </el-tab-pane>
        <el-tab-pane label="课件列表" name="courseware">
          <span v-if="tab=='courseware'">
            <router-view></router-view>
          </span>
        </el-tab-pane>
        <el-tab-pane label="公告列表" name="announcement">
          <span v-if="tab=='announcement'">
            <router-view></router-view>
          </span>
        </el-tab-pane>
        <el-tab-pane label="作业分组" name="sublet">
          <span v-if="tab=='sublet'">
            <router-view></router-view>
          </span>
        </el-tab-pane>
        <el-tab-pane label="作业列表" name="homework">
          <span v-if="tab=='homework'">
            <router-view></router-view>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "",
      teacherData: {}
    };
  },
  created() {
    const { path } = this.$route;
    this.tab = path.slice(path.lastIndexOf("/") + 1);
    this.ngOnInit();
  },
  methods: {
    goRouter(path) {
      this.$router.push(path);
    },
    selectTab() {
      // this.tab = name;
      // this.$router.push({ path: `/alliance/teacher/12/${name}` });
      this.$router.push({
        path: `/alliance/teacher/${this.tab}?schoolId=${this.$route.query.schoolId}&teacherId=${this.$route.query.teacherId}`
      });
    },
    ngOnInit() {
      // 获取教师信息query
      const paramTeacher = {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId
      };
      this.$api.allianceSchool.getTeacherInfo(paramTeacher).then(res => {
        if (res.errCode == 0) {
          this.teacherData = res.data;
          // this.schoolData = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
.teachingManagement {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.addExperiment-title {
  margin-bottom: 16px;
  span,
  i {
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #424346;
    font-style: normal;
    opacity: 1;
  }
  span {
    color: #939393;
    cursor: pointer;
  }
}
</style>